// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--Pf0cj","scroller":"_93444fe79c--scroller--m8ZYV","scroller--with-drag":"_93444fe79c--scroller--with-drag--WdczF"};